import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTreeview,{attrs:{"id":"tree","items":_vm.addressesTree,"transition":"","open-on-click":"","selectable":"","return-object":""},on:{"input":_vm.handleNodesInput},model:{value:(_vm.nodes),callback:function ($$v) {_vm.nodes=$$v},expression:"nodes"}})}
var staticRenderFns = []

export { render, staticRenderFns }